// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1dBRM","rootCenter":"LoadMoreObserver_rootCenter__13hP9","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2k5x1"};